// extracted by mini-css-extract-plugin
export default {"container":"UsernameFromNumber_container__dCFDv","tooltipContainer":"UsernameFromNumber_tooltipContainer__8ZtCF"};